import type * as React from "react";
import { toast } from "sonner";
import ApiKeysSection from "src/components/api-keys-section/api-keys-section";
import DevelopersSection from "src/components/developers-section/developers-section";
import WebhooksSection from "src/components/webhooks-section/webhooks-section";

const DeveloperPage: React.FC = () => {
	const openNotification = (title: string, description: string) => {
		toast.success(title, {
			description,
		});
	};

	return (
		<div className="space-y-6 p-4 sm:p-6">
			<h1 className="sr-only">Developer</h1>

			<div className="flex items-center gap-3">
				<span aria-hidden className="h-5 w-[3px] rounded-full bg-primary" />
				<p className="text-[11px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
					Developer · Keys, webhooks, and integration docs
				</p>
			</div>

			<DevelopersSection openPopupFunc={openNotification} />
			<ApiKeysSection openPopupFunc={openNotification} />
			<WebhooksSection openPopupFunc={openNotification} />
		</div>
	);
};

export default DeveloperPage;
